module.exports = __webpack_public_path__ + "static/media/uploadnube.5ea3e8af.svg";